module.exports = __webpack_public_path__ + "static/media/photo-1.0b9d6a4c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/willow-walk-remodelling/photo-1.jpg
// module id = 171
// module chunks = 0